/* zemulo-upsell.js — v4 (23.10.2026, round 6: new card design + visible gift pump row; v3.1 cart checks kept) · cart updates in place, no page reload.
 * Cart-only offers under the bundle line:
 *   - bundle 1 or 2  → "upgrade to next bundle" (+₪90)  [existing behaviour, now keeps the gift property]
 *   - any bundle     → "add an extra bag without pump" (add-on product, Unlisted)
 * Add-on lines are removed automatically if no bundle is left in the cart.
 */
(function () {
  var MAIN_PRODUCT_ID = 8725612789921;
  var MAIN_HANDLE = 'שקית-ואקום-zemulo-17l-עם-משאבה-חשמלית';
  var ADDON_HANDLE = 'zemulo-extra-bag';          // add-on product (status: Unlisted)
  var ADDON_PRODUCT_ID = 8814678245537;
  /* fallback if the .js fetch fails: 28L first (main offer), then 17L */
  var ADDON_FALLBACK = [
    { id: 48178952175777, title: 'תיק גדול 28 ליטר', price: 11900, available: true },
    { id: 48178952208545, title: 'תיק 17 ליטר', price: 9900, available: true }
  ];
  var GIFT_PROPS = { 'מתנה': 'משאבה חשמלית במתנה' };
  var BAGS = [1, 2, 3];
  /* real store photos (same files and crops as the bundle cards on the product page) */
  var IMG = function (f, v, q) { return 'https://www.zemulo.com/cdn/shop/files/' + f + '?v=' + v + '&' + q; };
  var PIC = {
    two17: IMG('2_17_5d655bbb-c927-40f3-8b2d-e2e4693734ca.png', 1789307162, 'crop=region&crop_left=20&crop_top=205&crop_width=930&crop_height=930&width=160&height=160'),
    bag28: IMG('28_8712ef61-e79e-4652-b9c8-c9daa03975a6.png', 1789306552, 'crop=region&crop_left=240&crop_top=110&crop_width=790&crop_height=1090&width=116&height=160'),
    bag17: IMG('17_3be31308-8ef6-4b7e-8c15-671b5274d9c3.png', 1789305550, 'crop=region&crop_left=30&crop_top=150&crop_width=640&crop_height=880&width=116&height=160'),
    pump:  IMG('17_9b5de0e9-07af-4aab-a215-41a993bed514.png', 1792208391, 'width=96&height=96&crop=center')
  };
  /* upgrade offer per current bundle position (0 = bundle 1, 1 = bundle 2) */
  var NEXT = [
    { head: 'שדרגו ל-2 תיקים', l1: '2 תיקים 17 ליטר', pics: ['two17'] },
    { head: 'שדרגו ל-3 תיקים', l1: 'כולל תיק גדול 28 ליטר', pics: ['two17', 'bag28'] }
  ];
  var TILE = { 17: { pic: 'bag17', hint: 'לחולצות ומכנסיים' }, 28: { pic: 'bag28', hint: 'לסוודרים ומעילים' } };
  var bundles = null, addon = null, cart = null, busy = false, tried = {};

  var css = document.createElement('style');
  css.textContent = [
    '.zu-cell{grid-column:1/-1;padding:0!important;border:0!important}',
    '.zu-wrap{direction:rtl;text-align:right;font-family:var(--font-body-family,inherit);color:#11192b}',
    /* gift row */
    '.zu-gift{display:flex;align-items:center;gap:10px;margin:2px 0 10px;padding:8px 10px;border:1px dashed #f3c9b3;border-radius:9px;background:#fffaf7}',
    '.zu-gift img{width:38px;height:38px;border-radius:7px;object-fit:cover;background:#fff;flex-shrink:0}',
    '.zu-gift__t{flex:1;min-width:0;font-size:14px;font-weight:700;line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    '.zu-gift__s{display:block;margin-top:2px;font-size:12px;font-weight:400;color:#5d6677}',
    '.zu-gift__p{flex-shrink:0;font-size:14px;font-weight:800;color:var(--z-accent,#ff5a1f)}',
    /* hero upgrade card */
    '.zu-up{position:relative;margin:4px 0 12px;padding:14px 12px 12px;border:2px solid var(--z-accent,#ff5a1f);border-radius:9px;background:#fff8f4;box-shadow:0 4px 14px rgba(255,90,31,.12)}',
    '.zu-up__tag{position:absolute;top:-11px;right:12px;height:22px;display:flex;align-items:center;padding:0 9px;border-radius:6px;background:var(--z-accent,#ff5a1f);color:#fff;font-size:12.5px;font-weight:700;line-height:1}',
    '.zu-up__row{display:flex;align-items:center;gap:10px}',
    '.zu-up__media{display:flex;align-items:center;gap:2px;flex-shrink:0}',
    '.zu-up__media img{width:50px;height:50px;border-radius:7px;object-fit:cover;background:#fff;display:block}',
    '.zu-up__media img.zu-tall{width:36px}',
    '.zu-up__media b{font-size:12px;color:#999;font-weight:700}',
    '.zu-up__txt{flex:1;min-width:0}',
    '.zu-up__h{white-space:nowrap;font-size:16px;font-weight:800;line-height:1.2}',
    '.zu-up__s{margin-top:3px;font-size:12.5px;line-height:1.3;color:#5d6677;white-space:nowrap}','.zu-up__s+.zu-up__s{margin-top:1px}',
    '.zu-up__top{display:flex;align-items:center;justify-content:space-between;gap:8px}',
    '.zu-up__p{flex-shrink:0;font-size:21px;font-weight:800;line-height:1;color:var(--z-accent,#ff5a1f);white-space:nowrap}',
    '.zu-btn{display:flex;align-items:center;justify-content:center;gap:6px;width:100%;margin-top:11px;padding:12px;border:0;border-radius:9px;background:var(--z-accent,#ff5a1f);color:#fff;font:inherit;font-size:16px;font-weight:700;line-height:1;cursor:pointer}',
    '.zu-btn:hover{background:var(--z-accent-dark,#e84a10)}',
    '.zu-btn[disabled],.zu-add[disabled]{opacity:.6;cursor:default}',
    /* secondary: extra bag tiles */
    '.zu-more{margin:0 0 12px}',
    '.zu-more__h{display:flex;align-items:baseline;gap:6px;margin:0 0 8px;font-size:14px;font-weight:700}',
    '.zu-more__h span{font-size:12px;font-weight:400;color:#5d6677}',
    '.zu-tiles{display:grid;grid-template-columns:1fr 1fr;gap:8px}',
    '.zu-tile{display:flex;flex-direction:column;gap:8px;padding:9px;border:1.5px solid #f6d9ca;border-radius:9px;background:#fff}',
    '.zu-tile__top{display:flex;align-items:center;gap:8px;min-width:0}',
    '.zu-tile__top img{width:36px;height:50px;border-radius:6px;object-fit:cover;background:#fff;flex-shrink:0}',
    '.zu-tile__txt{min-width:0}',
    '.zu-tile__l{font-size:14px;font-weight:800;line-height:1.2;white-space:nowrap}',
    '.zu-tile__u{margin-top:2px;font-size:11.5px;line-height:1.25;color:#5d6677;white-space:nowrap}',
    '.zu-tile__bot{display:flex;align-items:center;justify-content:space-between;gap:6px}',
    '.zu-tile__pr{font-size:15px;font-weight:800;white-space:nowrap}',
    '.zu-add{flex-shrink:0;padding:7px 10px;border:1.5px solid #11192b;border-radius:8px;background:#fff;color:#11192b;font:inherit;font-size:13px;font-weight:700;line-height:1;cursor:pointer;white-space:nowrap}',
    '.zu-add:hover{background:#11192b;color:#fff}',
    /* order summary line above the subtotal */
    '.zu-sum{display:flex;align-items:center;justify-content:center;gap:6px;margin:0 0 10px;padding:7px 10px;border-radius:9px;background:#fff1e9;font-size:13.5px;font-weight:700;line-height:1.3;color:#11192b;text-align:center}',
    '.zu-sum b{color:var(--z-accent,#ff5a1f)}',
    '.zu-hide{display:none!important}'
  ].join('');
  document.head.appendChild(css);

  function money(c) { return '\u20AA' + (c / 100).toLocaleString('he-IL', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }); }
  function getJSON(u) { return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }); }
  function post(u, b) {
    return fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) })
      .then(function (r) { return r.json().then(function (j) { return r.ok ? j : Promise.reject(j); }); });
  }

  function load() {
    return Promise.all([
      bundles ? bundles : getJSON('/products/' + encodeURIComponent(MAIN_HANDLE) + '.js').then(function (p) { return (bundles = p && p.variants); }),
      addon ? addon : getJSON('/products/' + ADDON_HANDLE + '.js').then(function (p) { return (addon = p && p.variants ? p.variants.filter(function (v) { return v.available; }) : ADDON_FALLBACK); }, function () { return (addon = ADDON_FALLBACK); }),
      getJSON('/cart.js').then(function (c) { return (cart = c); })
    ]);
  }

  function pos(variantId) { for (var i = 0; i < (bundles || []).length; i++) if (bundles[i].id === variantId) return i; return -1; }

  /* v3 (23.10.2026): re-render the cart in place instead of reloading the page.
   * The old reload closed the cart drawer and threw the shopper out of the cart */
  function html(s, sel) { var d = new DOMParser().parseFromString(s || '', 'text/html'); return d.querySelector(sel); }
  function swap(id, sel, s) {
    var host = document.getElementById(id); if (!host || !s) return false;
    var target = (sel && host.querySelector(sel)) || host, src = html(s, sel || '.shopify-section');
    if (!src) return false; target.innerHTML = src.innerHTML; return true;
  }
  function rerender(c) {
    var drawer = document.querySelector('cart-drawer');
    var mainItems = document.getElementById('main-cart-items'), mainFooter = document.getElementById('main-cart-footer');
    var jobs = [];
    if (drawer && document.getElementById('CartDrawer')) jobs.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '#CartDrawer' });
    if (mainItems && mainItems.dataset.id) jobs.push({ id: 'main-cart-items', section: mainItems.dataset.id, selector: '.js-contents' });
    if (mainFooter && mainFooter.dataset.id) jobs.push({ id: 'main-cart-footer', section: mainFooter.dataset.id, selector: '.js-contents' });
    if (!jobs.length) return Promise.reject();
    jobs.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    if (document.getElementById('cart-live-region-text')) jobs.push({ id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' });
    var ids = jobs.map(function (j) { return j.section; }).filter(function (v, i, a) { return a.indexOf(v) === i; });
    /* no JSON Accept header here: /cart with Accept: application/json returns the cart, not the sections */
    return fetch('/cart?sections=' + ids.join(','), { cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (secs) {
      if (!secs) throw new Error('sections');
      var empty = c.item_count === 0;
      jobs.forEach(function (j) {
        if (j.id === 'CartDrawer') {
          var wasOpen = drawer.classList.contains('active');
          var src = html(secs[j.section], '#CartDrawer'); if (!src) return;
          document.getElementById('CartDrawer').innerHTML = src.innerHTML;
          drawer.classList.toggle('is-empty', empty);
          var ov = drawer.querySelector('#CartDrawer-Overlay'); if (ov) ov.addEventListener('click', drawer.close.bind(drawer));
          if (wasOpen && !drawer.classList.contains('active')) drawer.classList.add('animate', 'active');
        } else swap(j.id, j.selector, secs[j.section]);
      });
      var ci = document.querySelector('cart-items'); if (ci) ci.classList.toggle('is-empty', empty);
      if (mainFooter) mainFooter.classList.toggle('is-empty', empty);
    });
  }
  function done() {
    return getJSON('/cart.js').then(function (c) { cart = c; return rerender(c); })
      .then(function () { busy = false; return refresh(); })
      .catch(function () { window.location.reload(); }); // last resort only
  }

  /* upgrade: remove old bundle line, add next bundle WITH the gift property */
  function upgrade(line, toId, btn) {
    if (busy) return; busy = true; if (btn) btn.disabled = true;
    /* v3.1: upgrade only a line that is still in the cart right now (a stale tab/button must not add a bundle) */
    getJSON('/cart.js')
      .then(function (c) {
        var cur = c && c.items && c.items.filter(function (x) { return x.key === line.key; })[0];
        if (!cur) return Promise.reject('stale');
        return post('/cart/change.js', { id: line.key, quantity: 0 }).then(function (c2) {
          if (!c2 || !c2.items || c2.items.some(function (x) { return x.key === line.key; })) return Promise.reject('not-removed');
          return post('/cart/add.js', { items: [{ id: toId, quantity: cur.quantity, properties: GIFT_PROPS }] });
        });
      })
      .then(done, function () { busy = false; return done(); });
  }
  function addExtra(variantId, btn) {
    if (busy) return; busy = true; if (btn) btn.disabled = true;
    /* v3.1: the extra bag is an add-on, so add it only while a bundle is in the cart right now */
    getJSON('/cart.js')
      .then(function (c) {
        if (!c || !c.items || !c.items.some(function (x) { return x.product_id === MAIN_PRODUCT_ID; })) return Promise.reject('no-bundle');
        return post('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
      })
      .then(done, function () { busy = false; return done(); });
  }

  function el(tag, cls, htmlStr) { var e = document.createElement(tag); if (cls) e.className = cls; if (htmlStr != null) e.innerHTML = htmlStr; return e; }
  function img(k, alt) { return '<img src="' + PIC[k] + '" alt="' + alt + '" loading="lazy" width="52" height="52"' + (k === 'bag28' || k === 'bag17' ? ' class="zu-tall"' : '') + '>'; }
  function liters(v) { var m = /(\d+)\s*ליטר/.exec(v.title || '') || /(\d+)\s*L/i.exec(v.title || ''); return m ? +m[1] : 0; }

  function giftRow(n) {
    return el('div', 'zu-gift', '<img src="' + PIC.pump + '" alt="משאבה חשמלית" loading="lazy" width="38" height="38">' +
      '<div class="zu-gift__t">🎁 משאבה חשמלית <bdi dir="ltr">×' + n + '</bdi><span class="zu-gift__s">מתנה עם ' + (n > 1 ? 'כל חבילה' : 'החבילה') + '</span></div>' +
      '<div class="zu-gift__p">חינם</div>');
  }
  function upCard(it, at, next, qty) {
    var o = NEXT[at], diff = (next.price - bundles[at].price) * qty;
    var per = money(Math.floor(next.price / BAGS[at + 1])) + ' לתיק';
    var c = el('div', 'zu-up', '<div class="zu-up__tag">שדרוג משתלם</div>' +
      '<div class="zu-up__row"><div class="zu-up__media">' + o.pics.map(function (k, i) { return (i ? '<b>+</b>' : '') + img(k, k === 'bag28' ? 'תיק 28 ליטר' : '2 תיקים 17 ליטר'); }).join('') + '</div>' +
      '<div class="zu-up__txt"><div class="zu-up__top"><div class="zu-up__h">' + o.head + '</div><div class="zu-up__p" dir="ltr">+' + money(diff) + '</div></div>' +
      '<div class="zu-up__s">' + o.l1 + '</div><div class="zu-up__s">' + per + (qty > 1 ? ' · ' + money(next.price - bundles[at].price) + ' לכל חבילה' : ' · משאבה במתנה') + '</div></div></div>');
    var b = el('button', 'zu-btn', 'שדרגו את החבילה ←'); b.type = 'button';
    b.addEventListener('click', function (e) { e.preventDefault(); upgrade(it, next.id, b); });
    c.appendChild(b); return c;
  }
  function moreBox(hero) {
    var list = (addon || []).slice().sort(function (a, b) { return a.price - b.price; });
    var m = el('div', 'zu-more', '<div class="zu-more__h">' + (hero ? 'עוד תיק לבד' : 'צריכים עוד תיק?') + '<span>בלי משאבה</span></div>');
    var g = el('div', 'zu-tiles');
    list.forEach(function (v) {
      var L = liters(v), t = TILE[L] || { pic: 'bag17', hint: '' };
      var tile = el('div', 'zu-tile', '<div class="zu-tile__top">' + img(t.pic, 'תיק ' + L + ' ליטר') +
        '<div class="zu-tile__txt"><div class="zu-tile__l">תיק ' + L + ' ליטר</div><div class="zu-tile__u">' + t.hint + '</div></div></div>');
      var bot = el('div', 'zu-tile__bot', '<span class="zu-tile__pr">' + money(v.price) + '</span>');
      var b = el('button', 'zu-add', '+ הוספה'); b.type = 'button'; b.setAttribute('aria-label', 'הוספת תיק ' + L + ' ליטר ב-' + money(v.price));
      b.addEventListener('click', function (e) { e.preventDefault(); addExtra(v.id, b); });
      bot.appendChild(b); tile.appendChild(bot); g.appendChild(tile);
    });
    m.appendChild(g); return m;
  }
  function rowQty(row, it) {
    var q = row.querySelector('input.quantity__input');
    var n = q ? parseInt(q.getAttribute('data-cart-quantity') || q.value, 10) : NaN;
    return n > 0 ? n : it.quantity;
  }
  function clearRow(row) { row.querySelectorAll('.zu-cell,.zu-wrap').forEach(function (o) { o.remove(); }); }

  function decorate() {
    if (!cart || !bundles) return;
    var hasBundle = cart.items.some(function (it) { return it.product_id === MAIN_PRODUCT_ID; });
    // add-on without bundle → remove (cart-only add-on)
    if (!hasBundle && !busy) {
      var orphan = cart.items.filter(function (it) { return it.product_id === ADDON_PRODUCT_ID || it.handle === ADDON_HANDLE; })[0];
      if (orphan && !tried[orphan.key]) { tried[orphan.key] = 1; busy = true; post('/cart/change.js', { id: orphan.key, quantity: 0 }).then(function () { tried = {}; return done(); }, function () { busy = false; }); return; }
    }
    var byKey = {}; cart.items.forEach(function (it) { byKey[it.key] = it; });
    var pumps = { drawer: 0, main: 0 };
    document.querySelectorAll('#CartDrawer .cart-item, #main-cart-items .cart-item').forEach(function (row) {
      var inp = row.querySelector('input[data-quantity-line-key]');
      var it = inp && byKey[inp.getAttribute('data-quantity-line-key')];
      if (!it || it.product_id !== MAIN_PRODUCT_ID) { if (row.querySelector('.zu-wrap')) clearRow(row); return; }
      var qty = rowQty(row, it), at = pos(it.variant_id);
      pumps[row.closest('#CartDrawer') ? 'drawer' : 'main'] += qty;
      // the gift is shown as its own row below, so hide Dawn's plain "מתנה: …" text and the short green note
      row.querySelectorAll('.zg-inline').forEach(function (z) { z.classList.add('zu-hide'); });
      row.querySelectorAll('.cart-item__details .product-option').forEach(function (p) { var dt = p.querySelector('dt'); if (dt && /^מתנה/.test(dt.textContent.trim())) p.classList.add('zu-hide'); });
      var mark = 'v4|' + it.key + '|' + qty + '|' + (addon ? addon.length : 0);
      if (row.querySelector('.zu-wrap[data-key="' + mark + '"]')) return;
      clearRow(row);
      var wrap = el('div', 'zu-wrap'); wrap.setAttribute('data-key', mark);
      wrap.appendChild(giftRow(qty));
      var next = at >= 0 && at < NEXT.length ? bundles[at + 1] : null;
      var hero = !!(next && next.available);
      if (hero) wrap.appendChild(upCard(it, at, next, qty));
      if (addon && addon.length) wrap.appendChild(moreBox(hero));
      if (window.getComputedStyle(row).display === 'grid') { var td = el('td', 'zu-cell'); td.appendChild(wrap); row.appendChild(td); }
      else { var det = row.querySelector('.cart-item__details'); if (det) det.appendChild(wrap); }
    });
    summary(document.querySelector('#CartDrawer .cart-drawer__footer .totals'), pumps.drawer);
    summary(document.querySelector('#main-cart-footer .totals'), pumps.main);
  }
  function summary(totals, n) {
    if (!totals) return;
    var old = totals.parentNode.querySelector('.zu-sum');
    var txt = n ? '🎁 בהזמנה שלכם: <b>' + (n > 1 ? n + ' משאבות חשמליות' : 'משאבה חשמלית') + '</b> מתנה' : '';
    if (old && old.getAttribute('data-n') === String(n)) return;
    if (old) old.remove();
    if (!n) return;
    var d = el('div', 'zu-sum', txt); d.setAttribute('data-n', String(n));
    totals.parentNode.insertBefore(d, totals);
  }

  function refresh() { return load().then(decorate).catch(function () {}); }
  var pending = false;
  new MutationObserver(function () {
    if (pending || busy) return; pending = true;
    requestAnimationFrame(function () { pending = false; if (document.querySelector('.cart-item')) decorate(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined')
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || e.source !== 'zemulo-upsell') setTimeout(refresh, 80); });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', refresh) : refresh();
})();
